/**
 * Stock Status Fix — Zen Grip
 * Reads variant select options, marks unavailable packs,
 * shows OOS message, and disables Add to Cart when needed.
 */
(function() {
  'use strict';

  function getSelectedColor() {
    // Try .selected class first
    const colorContainer = document.querySelectorAll('.variant-options')[0];
    if (colorContainer) {
      const selected = colorContainer.querySelector('.variant-option.selected');
      if (selected) return selected.getAttribute('data-variant-value');
    }
    // Fallback: read from select element
    const select = document.getElementById('variant-select');
    if (!select) return null;
    const opt = select.options[select.selectedIndex];
    if (!opt) return null;
    const parts = opt.text.split(' / ');
    return parts.length >= 1 ? parts[0] : null;
  }

  function getSelectedPack() {
    // Try .selected class first
    const containers = document.querySelectorAll('.variant-options');
    if (containers.length >= 2) {
      const selected = containers[1].querySelector('.variant-option.selected');
      if (selected) return selected.getAttribute('data-variant-value');
    }
    // Fallback: read from select element
    const select = document.getElementById('variant-select');
    if (!select) return null;
    const opt = select.options[select.selectedIndex];
    if (!opt) return null;
    const parts = opt.text.split(' / ');
    return parts.length >= 2 ? parts[1].split(' - ')[0] : null;
  }

  function getVariantAvailability(color, pack) {
    const select = document.getElementById('variant-select');
    if (!select) return null;
    for (const opt of select.options) {
      if (opt.text.includes(color + ' / ' + pack + ' ')) {
        return opt.getAttribute('data-available') === 'true';
      }
    }
    return null;
  }

  function getPackAvailabilityForColor(color) {
    const select = document.getElementById('variant-select');
    if (!select) return {};
    const result = {};
    for (const opt of select.options) {
      const parts = opt.text.split(' / ');
      if (parts.length >= 2 && parts[0] === color) {
        const pack = parts[1].split(' - ')[0];
        result[pack] = opt.getAttribute('data-available') === 'true';
      }
    }
    return result;
  }

  function markPacksForColor(color) {
    const containers = document.querySelectorAll('.variant-options');
    if (containers.length < 2) return;
    const packContainer = containers[1];
    const packButtons = packContainer.querySelectorAll('.variant-option');
    const availability = getPackAvailabilityForColor(color);

    packButtons.forEach(btn => {
      const packText = btn.getAttribute('data-variant-value');
      const isAvailable = availability[packText];
      if (isAvailable === false) {
        btn.style.opacity = '0.4';
        btn.style.textDecoration = 'line-through';
        btn.style.cursor = 'not-allowed';
        btn.setAttribute('data-available', 'false');
      } else {
        btn.style.opacity = '';
        btn.style.textDecoration = '';
        btn.style.cursor = '';
        btn.setAttribute('data-available', 'true');
      }
    });
  }

  function updateStockStatus() {
    const color = getSelectedColor();
    const pack = getSelectedPack();
    if (!color || !pack) return;

    const available = getVariantAvailability(color, pack);
    const statusDiv = document.querySelector('[data-stock-status]');
    const addToCartBtn = document.querySelector('[data-add-to-cart]');
    const priceEl = document.querySelector('[data-product-price]');
    const mobilePriceEl = document.querySelector('[data-mobile-price]');

    if (available === false) {
      // Out of stock
      if (statusDiv) {
        statusDiv.style.display = 'block';
        statusDiv.style.padding = '10px 16px';
        statusDiv.style.marginBottom = '12px';
        statusDiv.style.background = 'rgba(161, 44, 123, 0.08)';
        statusDiv.style.border = '1px solid rgba(161, 44, 123, 0.3)';
        statusDiv.style.borderRadius = '8px';
      }
      if (addToCartBtn) {
        addToCartBtn.style.opacity = '0.6';
        addToCartBtn.style.cursor = 'not-allowed';
        addToCartBtn.style.pointerEvents = 'none';
        addToCartBtn.textContent = 'Out of Stock';
      }
    } else {
      // In stock
      if (statusDiv) {
        statusDiv.style.display = 'none';
      }
      if (addToCartBtn) {
        addToCartBtn.style.opacity = '';
        addToCartBtn.style.cursor = '';
        addToCartBtn.style.pointerEvents = '';
        addToCartBtn.textContent = 'Add to Cart';
      }
    }
  }

  function handleVariantChange() {
    const color = getSelectedColor();
    if (color) markPacksForColor(color);
    updateStockStatus();
  }

  function init() {
    const select = document.getElementById('variant-select');
    if (!select) return;

    // Initial marking
    const color = getSelectedColor();
    if (color) markPacksForColor(color);
    updateStockStatus();

    // Listen to select changes
    select.addEventListener('change', handleVariantChange);

    // Listen to button clicks (delegate)
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.variant-option');
      if (!btn) return;
      // Wait for the button's own handler to update .selected
      setTimeout(handleVariantChange, 150);
    });
  }

  // Run after DOM ready and theme.js has initialized
  function start() {
    setTimeout(init, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
